import { Outlet, createRootRoute, createRoute, createRouter, redirect } from '@tanstack/react-router';
import { HiveRegisterPage } from '@/features/hive/HiveRegisterPage';
import { LandingPage } from '@/features/landing/LandingPage';
import { SignInPage } from '@/features/auth/SignInPage';
import { SignUpPage } from '@/features/auth/SignUpPage';
import { NotFoundPage } from '@/components/NotFoundPage';
import type { AppEntry } from '@/app/routes-types';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';
import { sessionSettled } from '@/lib/platform/auth';
import { resolveEntryRoute } from '@/lib/platform/routing';

export const entry: AppEntry = { default: '/hives', byRole: {} };

const rootRoute = createRootRoute({
  component: Outlet,
  notFoundComponent: NotFoundPage,
});

const landingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: LandingPage,
  staticData: { title: 'Hive Register', page: 'landing', standalone: true, isPublic: true },
});

const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'sign-in',
  component: SignInPage,
  beforeLoad: async () => {
    const session = await sessionSettled();
    if (session.status === 'authed') throw redirect({ to: resolveEntryRoute(entry, session.user?.roles ?? []) });
  },
  staticData: { title: 'Sign in', page: 'sign-in', standalone: true, isPublic: true },
});

const signUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'sign-up',
  component: SignUpPage,
  beforeLoad: async () => {
    const session = await sessionSettled();
    if (session.status === 'authed') throw redirect({ to: resolveEntryRoute(entry, session.user?.roles ?? []) });
  },
  staticData: { title: 'Create account', page: 'sign-up', standalone: true, isPublic: true },
});

const hivesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'hives',
  component: HiveRegisterPage,
  beforeLoad: () => guardSurface(entry, SURFACES['hive-register']),
  staticData: { title: 'Hive register', page: SURFACES['hive-register'], standalone: false, isPublic: false },
});

const routeTree = rootRoute.addChildren([landingRoute, signInRoute, signUpRoute, hivesRoute]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
